module.exports = ".MenuSectionContainer,\n.MenuSection {\n  float: left;\n  width: 100%;\n}\n\n.ul-menu-items {\n  padding: 0;\n  margin-bottom: 0;\n  float: left;\n  width: 100%;\n  list-style: none;\n}\n\n.ul-menu-items li {\n  width: 100%;\n  float: left;\n  clear: both;\n  text-align: center;\n}\n\n.ul-menu-items li a {\n  color: #fff;\n  font-weight: 300;\n  display: block;\n  padding: 5px 0;\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/nav-item/nav-item.component.css
// module id = ./src/app/core/components/nav-item/nav-item.component.css
// module chunks = main